module.exports = __webpack_public_path__ + "img/4sczt.f1adab6e.png";